import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v("Orders Dispatch")]), _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      placeholder: "Search for a reference (...001)",
      clearable: "",
      "hide-details": "auto",
      loading: _vm.isDataLoading,
      "append-icon": "fa-search"
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.label != _vm.searchLabelLastUsed && _vm.search(true);
      },
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields",
    class: !_vm.isAdvancedFiltering && !_vm.isAdvancedFilterOpened ? "--collapsed" : "--opened"
  }, [_c("div", [_c(VAutocomplete, {
    staticStyle: {
      "min-width": "33%"
    },
    attrs: {
      items: _vm.paymentStates,
      "item-value": "id",
      "item-text": "name",
      label: "Payment state",
      "hide-details": "auto",
      clearable: "",
      solo: "",
      multiple: ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.paymentStates != _vm.searchPaymentStatesSearchLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paymentStates,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "paymentStates", $$v);
      },
      expression: "formSearch.paymentStates"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.listCustomer,
      "item-value": "id_user",
      "item-text": "labelForList",
      label: _vm.isLoadingListCustomer ? "Loading list..." : "Customers",
      "hide-details": "auto",
      clearable: "",
      solo: "",
      multiple: "",
      chips: "",
      "deletable-chips": ""
    },
    on: {
      blur: function blur($event) {
        _vm.formSearch.customerIds != _vm.searchCustomerIdsSearchLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.customerIds,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "customerIds", $$v);
      },
      expression: "formSearch.customerIds"
    }
  }), _c(VSelect, {
    attrs: {
      label: _vm.isLoadingListConsultant ? "Loading list..." : "Consultant",
      items: _vm.listConsultant,
      "item-value": "id_user",
      "item-text": "fullname",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      },
      blur: function blur($event) {
        _vm.formSearch.consultantId != _vm.searchConsultantIdLastUsed && _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.consultantId,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "consultantId", $$v);
      },
      expression: "formSearch.consultantId"
    }
  })], 1)]), _c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", {
    staticClass: "tags"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToFinalize ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_finalize");
      }
    }
  }, [_vm._v(" To finalize ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToValidate ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_validate");
      }
    }
  }, [_vm._v(" To validate ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToPrepare ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_prepare");
      }
    }
  }, [_vm._v(" To prepare ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToShip ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_ship");
      }
    }
  }, [_vm._v(" To ship ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInTransit ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("in_transit");
      }
    }
  }, [_vm._v(" In delivery ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringDelivered ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("delivered");
      }
    }
  }, [_vm._v(" Delivered ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringCancelled ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("cancelled");
      }
    }
  }, [_vm._v(" Cancelled ")]), _vm.isFilteringStatus ? _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.clearFiltersStatus
    }
  }, [_vm._v(" Clear all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-close")])], 1) : _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.fillFiltersStatus
    }
  }, [_vm._v(" Add all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)]), _c("div", {
    staticClass: "search-pagination-index --with-collapse-trigger"
  }, [_c("div", [!_vm.isAdvancedFiltering && !_vm.isAdvancedFilterOpened ? _c("span", {
    staticClass: "router-link",
    on: {
      click: function click() {
        _vm.isAdvancedFilterOpened = true;
      }
    }
  }, [_vm._v(" + filters ")]) : !_vm.isAdvancedFiltering ? _c("span", {
    staticClass: "router-link",
    on: {
      click: function click() {
        _vm.isAdvancedFilterOpened = false;
      }
    }
  }, [_vm._v(" - filters ")]) : _vm._e()]), _c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.inboundDeliveryCount
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "inbound-delivery-table cursor--pointer",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": +_vm.formSearch.paging.limits,
      "hide-default-footer": "",
      "disable-sort": "",
      "item-key": "id"
    },
    on: {
      "click:row": _vm.rowClick,
      "contextmenu:row": _vm.rowClickContextMenu
    },
    scopedSlots: _vm._u([{
      key: "item.reference",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "td-without-link",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "inbound-delivery-reference-column"
        }, [_c("div", {
          staticClass: "inbound-delivery-collapsis",
          attrs: {
            title: "See more details"
          },
          on: {
            click: function click($event) {
              item.isExpanded = !item.isExpanded;
            }
          }
        }, [_c(VIcon, [_vm._v(_vm._s(!item.isExpanded ? "mdi-chevron-down" : "mdi-chevron-up"))])], 1), _c("div", {
          staticClass: "inbound-delivery-ref"
        }, [_c("div", {
          staticClass: "flex"
        }, [_c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.deliveryDetails(item)
          }
        }, [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500,
            disabled: item.isOrderExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c("strong", [_vm._v(_vm._s(item.reference))])])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v(_vm._s(_vm._f("formatDate")(item.validatedAt)))])])], 1)], 1), _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                attrs = _ref3.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  small: ""
                },
                on: {
                  click: function click($event) {
                    return _vm.copyToClipboard(item.reference);
                  }
                }
              }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
            }
          }], null, true)
        }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
          staticStyle: {
            color: "green"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1), _c(VExpandTransition, [item.Expanded ? _c("div", {
          staticClass: "expanded-section"
        }, [_c("i", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.validatedAt)) + ")")])]) : _vm._e()])], 1)])])];
      }
    }, {
      key: "item.customer",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref5) {
              var on = _ref5.on,
                attrs = _ref5.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VExpandTransition, [_c("div", {
                domProps: {
                  innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.user)))
                }
              })]), _c(VExpandTransition, [item.isExpanded ? _c("div", {
                domProps: {
                  innerHTML: _vm._s("<span class='text-smaller text-italic'>" + _vm.userGroupName(item.user) + "</span>")
                }
              }) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [item.user.company_name ? _c("div", [_vm._v("Company: " + _vm._s(item.user.company_name))]) : _vm._e(), _c("div", {
          domProps: {
            innerHTML: _vm._s("<span class=' text-italic'>" + _vm.userGroupName(item.user) + "</span>")
          }
        })])], 1)];
      }
    }, {
      key: "item.status",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                attrs = _ref7.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c("div", {
                staticClass: "badge --small",
                class: _vm.getStatusClass(item)
              }, [_vm._v(" " + _vm._s(_vm.inboundDeliveryStatus.find(function (x) {
                return x.status == item.status;
              }).shortValue) + " ")]), _c(VExpandTransition, [item.isExpanded ? _c("div", {
                staticClass: "expanded-section"
              }, [_c("i", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.lastStatusUpdateDate)) + ")")])]) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v(_vm._s(_vm._f("formatDate")(item.lastStatusUpdateDate)))])])], 1)];
      }
    }, {
      key: "item.totalAmountCurrencyIncludeShipping",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref9) {
              var on = _ref9.on,
                attrs = _ref9.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "amount-column"
              }, "div", attrs, false), on), [_c("div", [_vm._v(" " + _vm._s(_vm.formatPrice(item.totalAmountCurrencyIncludeShipping)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")]), _c(VExpandTransition, [item.isExpanded ? _c("div", {
                staticClass: "quantity"
              }, [_c("i", [_vm._v(" " + _vm._s("(".concat(item.totalQuantity, " bottle").concat(item.totalQuantity > 1 ? "s" : "", ")")) + " ")])]) : _vm._e()])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", {
          staticClass: "quantity"
        }, [_vm._v(" " + _vm._s("".concat(item.totalQuantity, " bottle").concat(item.totalQuantity > 1 ? "s" : "")) + " ")])])], 1)];
      }
    }, {
      key: "item.deliveryAddress",
      fn: function fn(_ref10) {
        var _item$deliveryAddress3;
        var item = _ref10.item;
        return [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "close-on-content-click": false,
            "open-delay": 500,
            disabled: item.isExpanded
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref11) {
              var _item$deliveryAddress, _item$deliveryAddress2;
              var on = _ref11.on,
                attrs = _ref11.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "delivery-address-column"
              }, "div", attrs, false), on), [_c("div", [_c(VExpandTransition, [item.isExpanded ? _c("div", {
                on: {
                  click: function click($event) {
                    $event.stopPropagation();
                  }
                }
              }, [_c("div", {
                staticClass: "td-without-link"
              }, [_c("div", [_vm._v(_vm._s(item.deliveryAddress.street))]), item.deliveryAddress.address_line_2 ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_line_2) + " ")]) : _vm._e(), item.deliveryAddress.address_line_3 ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_line_3) + " ")]) : _vm._e(), item.deliveryAddress.address_complement ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_complement) + ", ")]) : _vm._e(), _c("div", [_vm._v(" " + _vm._s((item.deliveryAddress.zip ? item.deliveryAddress.zip + " " : "") + item.deliveryAddress.city) + " ")]), _c("div", [_vm._v(" " + _vm._s(((_item$deliveryAddress = item.deliveryAddress.state) !== null && _item$deliveryAddress !== void 0 && _item$deliveryAddress.state_label ? item.deliveryAddress.state.state_label + ", " : "") + item.deliveryAddress.country.printable_name) + " ")])])]) : _vm._e()]), _c(VExpandTransition, [!item.isExpanded ? _c("div", {
                staticClass: "delivery-address-default"
              }, [_vm._v(" " + _vm._s(item.deliveryAddress.country.printable_name + ", " + item.deliveryAddress.city + ((_item$deliveryAddress2 = item.deliveryAddress.state) !== null && _item$deliveryAddress2 !== void 0 && _item$deliveryAddress2.iso_state ? ", " + item.deliveryAddress.state.iso_state : "")) + " ")]) : _vm._e()])], 1)])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", {
          staticClass: "text-left"
        }, [_c("div", [_vm._v(_vm._s(item.deliveryAddress.street))]), item.deliveryAddress.address_line_2 ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_line_2) + " ")]) : _vm._e(), item.deliveryAddress.address_line_3 ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_line_3) + " ")]) : _vm._e(), item.deliveryAddress.address_complement ? _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.address_complement) + ", ")]) : _vm._e(), _c("div", [_vm._v(_vm._s(item.deliveryAddress.country.printable_name))]), _c("div", [_vm._v(" " + _vm._s(item.deliveryAddress.city + ((_item$deliveryAddress3 = item.deliveryAddress.state) !== null && _item$deliveryAddress3 !== void 0 && _item$deliveryAddress3.state_label ? ", " + item.deliveryAddress.state.state_label : "") + (item.deliveryAddress.zip ? ", " + item.deliveryAddress.zip : "")) + " ")])])])], 1)];
      }
    }, {
      key: "item.warehouse",
      fn: function fn(_ref12) {
        var item = _ref12.item;
        return [_c("div", [_vm._v(" " + _vm._s(item.warehouse.name) + " ")])];
      }
    }, {
      key: "item.carrier",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [item.carrier.name ? _c("div", [_vm._v(" " + _vm._s(item.carrier.name) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.validatedAt",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [item.validatedAt ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.validatedAt)) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.deliveredAt",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [item.deliveredAt ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.deliveredAt)) + " ")]) : item.shipmentDate ? _c("div", [_vm._v("Pick-Up : " + _vm._s(_vm._f("formatDate")(item.shipmentDate)))]) : _c("div", [_vm._v(_vm._s(_vm.emptyCellContent))])];
      }
    }, {
      key: "item.dueDate",
      fn: function fn(_ref16) {
        var item = _ref16.item;
        return [item.dueDate ? _c("div", [_vm._v(" " + _vm._s(_vm._f("formatDate")(item.dueDate)) + " ")]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.paymentState",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [item.paymentState ? _c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500,
            disabled: true
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref18) {
              var on = _ref18.on,
                attrs = _ref18.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "payment-state-column"
              }, "div", attrs, false), on), [_c("div", [_c("svg", {
                staticClass: "icon icon-xxs dot",
                class: [_vm.getPaymentStateClass(item)],
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "512",
                  height: "512",
                  viewBox: "0 0 512 512"
                }
              }, [_c("circle", {
                attrs: {
                  cx: "256",
                  cy: "256",
                  r: "256"
                }
              })]), item.paymentState === _vm.paymentState.SUCCEEDED ? _c("div", [_vm._v("Paid")]) : _vm._e(), item.paymentState === _vm.paymentState.ACKNOWLEDGED ? _c("div", [_vm._v("In review")]) : _vm._e(), item.paymentState !== _vm.paymentState.SUCCEEDED && item.paymentState !== _vm.paymentState.ACKNOWLEDGED ? _c("div", [_vm._v(" " + _vm._s(item.paymentState) + " ")]) : _vm._e(), item.paymentDate ? _c("div", [_vm._v("(" + _vm._s(_vm._f("formatDate")(item.paymentDate)) + ")")]) : _vm._e()]), _vm.isPaymentStateLate(item) ? _c("div", {
                staticClass: "overdue-text"
              }, [_c("div", [_vm._v(" " + _vm._s("Overdue by ".concat(Date.diffDays(new Date(item.dueDate), new Date()), " days ")) + " ")])]) : _vm._e()])];
            }
          }], null, true)
        }) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.consultant",
      fn: function fn(_ref19) {
        var _item$consultant;
        var item = _ref19.item;
        return [_c("div", [_vm._v(" " + _vm._s(!String.isNullOrEmpty((_item$consultant = item.consultant) === null || _item$consultant === void 0 ? void 0 : _item$consultant.fullname) ? item.consultant.fullname : _vm.emptyCellContent) + " ")])];
      }
    }, {
      key: "item.creator",
      fn: function fn(_ref20) {
        var _item$creator;
        var item = _ref20.item;
        return [item.user.id_user != ((_item$creator = item.creator) === null || _item$creator === void 0 ? void 0 : _item$creator.id_user) ? _c("div", [_c("div", {
          domProps: {
            innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.creator)))
          }
        })]) : _c("div", [_vm._v(" " + _vm._s(_vm.emptyCellContent) + " ")])];
      }
    }], null, true)
  })], 1), _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_vm.numberOfPages ? _c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.inboundDeliveryCount
    }
  })], 1)])]), _c("Confirm", {
    ref: "confirm"
  }), _c("ContextMenu", {
    ref: "contextMenu"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };